// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2K6Zd","left":"InfoRow_left__2JAKM"};